import ListReception from './ListReception.jsx';
export {
  ListReception
};



// WEBPACK FOOTER //
// ./src/components/modules/reception/list-reception/index.js